import { apiFetch } from "../http";
export async function uploadAdminSeoLandingImage(params) {
    const body = new FormData();
    body.append("image", params.image);
    const data = await apiFetch(`/api/admin/seo-landings/${params.landingPageId}/images/${params.kind}/`, {
        baseUrl: params.baseUrl, token: params.token, method: "POST", body,
        headers: params.csrfToken ? { "X-CSRFToken": params.csrfToken } : undefined,
    });
    return assertSuccess(data, "Не удалось загрузить изображение подборки");
}
export async function deleteAdminSeoLandingImage(params) {
    const data = await apiFetch(`/api/admin/seo-landings/${params.landingPageId}/images/${params.kind}/`, {
        baseUrl: params.baseUrl, token: params.token, method: "DELETE",
        headers: params.csrfToken ? { "X-CSRFToken": params.csrfToken } : undefined,
    });
    return assertSuccess(data, "Не удалось удалить изображение подборки");
}
export async function uploadAdminSeoLandingCover(params) {
    const body = new FormData();
    body.append("image", params.image);
    const data = await apiFetch(`/api/admin/seo-landings/${params.landingPageId}/cover/`, {
        baseUrl: params.baseUrl, token: params.token, method: "POST", body,
        headers: params.csrfToken ? { "X-CSRFToken": params.csrfToken } : undefined,
    });
    return assertSuccess(data, "Не удалось загрузить обложку");
}
export async function deleteAdminSeoLandingCover(params) {
    const data = await apiFetch(`/api/admin/seo-landings/${params.landingPageId}/cover/`, {
        baseUrl: params.baseUrl, token: params.token, method: "DELETE",
        headers: params.csrfToken ? { "X-CSRFToken": params.csrfToken } : undefined,
    });
    return assertSuccess(data, "Не удалось удалить обложку");
}
const assertSuccess = (data, fallback) => {
    if ((data === null || data === void 0 ? void 0 : data.success) === false)
        throw new Error(data.error || fallback);
    return data;
};
export async function getSeoLandingPages(params) {
    const data = await apiFetch("/api/seo-landings/", {
        baseUrl: params.baseUrl,
        method: "GET",
    });
    return assertSuccess(data, "Не удалось загрузить страницы направлений");
}
export async function getSeoLandingPage(params) {
    const data = await apiFetch(`/api/seo-landings/${encodeURIComponent(params.slug)}/`, {
        baseUrl: params.baseUrl,
        method: "GET",
    });
    return assertSuccess(data, "Не удалось загрузить страницу направления");
}
const adminOptions = (token, csrfToken) => ({
    token,
    headers: {
        "Content-Type": "application/json",
        ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
    },
});
export async function getAdminSeoLandingPages(params) {
    const data = await apiFetch("/api/admin/seo-landings/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
    });
    return assertSuccess(data, "Не удалось загрузить SEO-страницы");
}
export async function getAdminSeoRouteOptions(params) {
    const data = await apiFetch("/api/admin/seo-landings/routes/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
    });
    return assertSuccess(data, "Не удалось загрузить публичные маршруты");
}
export async function createAdminSeoLandingPage(params) {
    const data = await apiFetch("/api/admin/seo-landings/", {
        baseUrl: params.baseUrl,
        method: "POST",
        ...adminOptions(params.token, params.csrfToken),
        body: JSON.stringify(params.page),
    });
    return assertSuccess(data, "Не удалось создать SEO-страницу");
}
export async function updateAdminSeoLandingPage(params) {
    const data = await apiFetch(`/api/admin/seo-landings/${params.landingPageId}/`, {
        baseUrl: params.baseUrl,
        method: "PATCH",
        ...adminOptions(params.token, params.csrfToken),
        body: JSON.stringify(params.page),
    });
    return assertSuccess(data, "Не удалось сохранить SEO-страницу");
}
export async function deleteAdminSeoLandingPage(params) {
    await apiFetch(`/api/admin/seo-landings/${params.landingPageId}/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "DELETE",
        headers: params.csrfToken ? { "X-CSRFToken": params.csrfToken } : undefined,
    });
}
